<script setup lang="ts">
import { MaybeRef } from 'vue';
import { defaultUrls } from '../../../stores/config';
import { EndpointResponse } from '../../../types/base';
import PejerGraph from '../PejerGraph.vue';
defineProps<{
  data: MaybeRef<EndpointResponse<(typeof defaultUrls)['payments']['stats']>>
}>()
</script>
<template>
  <PejerGraph
    :data="data"
    is-money
    :data-options="[
      {
        key: 'totalTransactionVolume',
        name: 'Total Transaction Volume',
        color: '#13b982',
        formatter: (value) => value / 100,
      },
    ]"
  />
</template>
